// progress bars
 function progressBar(className,countTo){
    jQuery(className).each(function() {
    let percent = jQuery(this).attr('data-value');
     percent =  countTo;
  if(percent > 100){
    percent = 100;
  } 
  jQuery(this).animate({width: percent+'%' }, 2000);
});
    }


  // count number
   function numberCounter(className){
     jQuery(className).each((i, el) => {
    var $counter = jQuery(el);
    if (!$counter.isInViewport() || $counter.data('animation-started'))
      return;

    $counter.data('animation-started', true).prop('Counter', 0).animate({
      Counter: $counter.text()
    }, {
      duration: 2000,
      easing: 'swing',
      step: function(now) {
        $counter.text(Math.ceil(now));
      }
    });
  });
  }



 jQuery(window).scroll(function(){
         numberCounter('.air-iconstxt .prose .heading_prose h2');
           
      });

 jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.airimage-overlay').offset().top + jQuery('.airimage-overlay').height() || jQuery(window).scrollTop() > jQuery('.airimage-overlay').offset().top)
      {
          numberCounter('.right-left-img-1 .content-progress-bar h2 span');
          progressBar(".right-left-img-1 .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-1 .second-bar .progressbar .bar","50");
     }
      });
   jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-1').offset().top + jQuery('.right-left-img-1').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-1').offset().top)
       {
       numberCounter('.right-left-img-2 .content-progress-bar h2 span');
          progressBar(".right-left-img-2 .show_for_desktop .first-bar .progressbar .bar","60");
          progressBar(".right-left-img-2 .show_for_desktop .second-bar .progressbar .bar","100");
            progressBar(".right-left-img-2 .show_for_mobile .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .second-bar .progressbar .bar","50");
       }
      });

     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-2').offset().top + jQuery('.right-left-img-2').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-2').offset().top)
       {
       numberCounter('.right-left-img-3 .content-progress-bar h2 span');
          numberCounter('.right-left-img-3 .cotnet-prers p span');
         
        numberCounter('.elite-right-left-img-3 .content-progress-bar h2 span');
          numberCounter('.right-left-img-3-4-mob .top-left-img-section .content-progress-bar h2 span');
          numberCounter('.right-left-img-3-4-mob .right-image-section .content-progress-bar h2 span');

         progressBar(".elite-right-left-img-3 .first-bar .progressbar .bar","100");
          progressBar(".elite-right-left-img-3 .second-bar .progressbar .bar","50");
                      
      progressBar(".right-left-img-3-4-mob .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-3-4-mob .second-bar .progressbar .bar","40");
       }
      });

  
     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-3').offset().top + jQuery('.right-left-img-3').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-3').offset().top)
       {
         numberCounter('.right-left-img-7 .content-progress-bar h2 span');
         
       }
      });


// Checks if any particular element is in viewport
jQuery.fn.isInViewport = function() {
  var elementTop = jQuery(this).offset().top;
  var elementBottom = elementTop + jQuery(this).outerHeight();
  var viewportTop = jQuery(window).scrollTop();
  var viewportBottom = viewportTop + jQuery(window).height();
  return elementTop < viewportBottom;
};
     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-6').offset().top + jQuery('.right-left-img-6').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-6').offset().top)
        {
        jQuery('.right-left-img-7 .content-progress-bar h2 span').each((i, el) => {
    var $counter = jQuery(el);
    if (!$counter.isInViewport() || $counter.data('animation-started'))
      return;

    $counter.data('animation-started', true).prop('Counter', 0).animate({
      Counter: $counter.text()
    }, {
      duration: 2000,
      easing: 'swing',
      step: function(now) {
        $counter.text(Math.ceil(now)+'%');
      }
    });
  });
        }
      });
  